export default __webpack_public_path__ + "static/media/Deliveroo.590dbbea.svg";